/**
 * Path level (1-4) of every v1 path lesson. Filled by ./curriculum (bundled worlds) or, on the client, from the
 * generated content index — so modules that only need the level (colouring coach) do not import the worlds.
 */
export const LESSON_LEVEL: Record<string, number> = {};
